import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=963f77d4&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./preview.vue?vue&type=style&index=1&id=963f77d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963f77d4",
  null
  
)

export default component.exports